(function()
{
	"use strict";

	function MapShip()
	{
		this.Container_constructor();

		this.mouseEnabled = false;
		this.ship = new cjs.Sprite(cm.Assets.lib.mapSS, "map-ship").center();
		this.ship.snapToPixel = false;
		this.name = "MapShip";
		this.addChild(this.ship);
		this.tweenShip();
	}

	var p = createjs.extend(MapShip, cjs.Container);

	p.tweenShip = function()
	{
		cjs.Tween.get(this.ship, {loop:true}).to({y: this.ship.y - 10}, 750, cjs.Ease.sineInOut).to({y:this.ship.y}, 750, cjs.Ease.sineInOut);
	};

	p.setActive = function( bool )
	{
		if(bool)
		{

		}
		else
		{

		}
	};

	p._tick = function(e)
	{
		this.Container__tick(e);

	};

	cm.MapShip = cjs.promote(MapShip, "Container");
})();
